import CustomButton from "../../../../../components/CustomButton";
import SvgIcon from "../../../../../helpers/SvgIcon";

import { useAppDispatch } from "../../../../../redux/hooks";
import { AssignedDriverDataInterface } from "../../../../../redux/interfaces/transport.interface";
import { fetchDeactivateOrActivateRoute } from "../../../../../redux/api/transport.api";
import { setAssignDriver } from "../../../../../redux/reducer/transport.reducer";
import { useNavigate } from "react-router-dom";
import { transportRoutes } from "../../../../../router/routesConstants";

function AssignDriverActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: AssignedDriverDataInterface;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleCopyDriver = () => {
    dispatch(setAssignDriver(crudData));
    navigate(transportRoutes.assignDriver);
  };

  const handleCopyDriverRoutes = () => {
    dispatch(setAssignDriver(crudData));
    navigate(transportRoutes.copyDriverRoutes);
  };

  const handleDeactivateDriver = () => {
    dispatch(
      fetchDeactivateOrActivateRoute({
        id_sofer_rute: itemId,
        activ: 2,
      }),
    );
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        color="primary"
        className="mt-1 me-1"
        tooltipTitle="Copiaza ruta"
        onClick={handleCopyDriver}>
        <SvgIcon type="DOCUMENTS" />
      </CustomButton>
      <CustomButton
        variant="contained"
        color="primary"
        className="mt-1 me-1"
        tooltipTitle="Copiaza toate rutele"
        onClick={handleCopyDriverRoutes}>
        <SvgIcon type="SPLIT_LIST" />
      </CustomButton>
      {(crudData.id_ruta || crudData.id_ruta_intranod) && (
        <CustomButton
          variant="contained"
          color="error"
          className="mt-1 me-1"
          tooltipTitle="Dezactivare ruta"
          withConfirmationModal={{
            modalTitle: "Doriti sa dezactivati ruta?",
            modalSubtitle: `${crudData.nume} ${crudData.prenume} -> ${
              crudData.ruta || crudData.intranod
            }`,
            modalRightButtonText: "Da",
            modalLeftButtonText: "Nu",
            modalRightButtonOnClick: handleDeactivateDriver,
          }}>
          <SvgIcon type="CLOSE_ICON" />
        </CustomButton>
      )}
    </div>
  );
}

export default AssignDriverActionButton;
